module.exports = __webpack_public_path__ + "img/ares.3b25f966.png";